import axios from 'plugins/axios'

export const state = {
  list: []
}

export const getters = {
  options (state) {
    return state.list
  },
  optionValues (state) {
    let optionValues = []
    state.list.forEach((option) => {
      option.values.forEach((value) => {
        if (!optionValues.find(ov => ov.id === value.id)) {
          optionValues.push(value)
        }
      })
    })
    return optionValues
  },
  getOptionByOptionId: (state) => (id) => {
    if (state.list.length === 0) return null
    return state.list.filter(option => option.id === id)
  },
  getOptionByOptionValueId: (state) => (oVId) => {
    let optionValues = getters.optionValues(state)
    let optionValue = optionValues.find(value => value.id === oVId)
    if (!optionValue) {
      return null
    }
    return state.list.find(o => o.id === optionValue.option_id)
  },
  getOptionValueByOptionValueId: (state, getters) => (oVId) => {
    let optionValues = getters.optionValues
    if (optionValues.length === 0) return null
    return optionValues.find(value => value.id === oVId)
  }
}

export const mutations = {
  add (state, option) {
    let oldOption = state.list.find(c => c.id === option.id)

    if (oldOption) {
      return state.list.splice(state.list.indexOf(oldOption), 1, option)
    }

    return state.list.push(option)
  }
}

export const actions = {
  async request ({state, commit}, forceRequest) {
    if (!forceRequest && state.list.length) return
    let {data} = await axios.get('/options')
    data.data.forEach(option => commit('add', option))
  }
}



// WEBPACK FOOTER //
// ./client/store/options.js